function r(n) {
  let e = n.parentElement, l = null;
  for (; e && !(e instanceof HTMLFieldSetElement); ) e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
  let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
  return t && i(l) ? false : t;
}
function i(n) {
  if (!n) return false;
  let e = n.previousElementSibling;
  for (; e !== null; ) {
    if (e instanceof HTMLLegendElement) return false;
    e = e.previousElementSibling;
  }
  return true;
}
export {
  r as isDisabledReactIssue7711
};
